import state from './state';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';

export default {
	state,
	mutations,
	actions,
	getters,
	modules: {}
};

// import Vue from 'vue';
// import Vuex from 'vuex';
// Vue.use(Vuex);

// import VuexPersist from 'vuex-persist';
// const vuexPersist = new VuexPersist({
// 	key: 'communico',
// 	storage: window.localStorage
// });

// import state from './state';
// import mutations from './mutations';
// import actions from './actions';
// import getters from './getters';

// export default new Vuex.Store({
// 	plugins: [vuexPersist.plugin],
// 	state,
// 	mutations,
// 	actions,
// 	getters,
// 	modules: {}
// });
